import { useContext, useMemo } from 'react';
import queryString from 'query-string';
import { useLocation, __RouterContext } from 'react-router';
import { useRouter } from 'next/router';

const useQueryParams = <
  T extends queryString.ParsedQuery<string> = queryString.ParsedQuery<string>,
>(): T => {
  const usingReactRouter = useContext(__RouterContext);
  const defaultParams: T = queryString.parse('') as T;

  /* eslint-disable react-hooks/rules-of-hooks */
  if (usingReactRouter) {
    const location = useLocation();
    const queryParams: T = useMemo(() => {
      return !location.search ? defaultParams : (queryString.parse(location.search) as T);
    }, [location.search, defaultParams]);
    return queryParams;
  }

  const router = useRouter();
  const queryParams: T = useMemo(() => {
    return !router.query ? defaultParams : (router.query as T);
  }, [router.query, defaultParams]);
  return queryParams;
};

export default useQueryParams;
